// @flow

import React, { type Node } from 'react';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { IfFeature } from '@tectonics/prs/feature';
import { InputCustomerName } from './input-customer-name';
import { InputCustomerEmail } from './input-customer-email';
import {
  InputBrazilianDocument,
  InputBrazilianPhoneNumber,
  InputBrazilianZipcode,
} from './brazilian';

import {
  InputMexicanPhoneNumber,
  InputMexicanZipcode,
} from './mexican';

import {
  InputArgentineDocument,
  InputArgentineDocumentType,
  InputArgentinePhoneNumber,
  InputArgentineZipcode,
} from './argentine';

import {
  InputColombianDocument,
  InputColombianDocumentType,
  InputColombianPhoneNumber,
  InputColombianZipcode,
} from './colombian';

import {
  InputEcuadorianDocument,
  InputEcuadorianPhoneNumber,
} from './ecuadorian';

import {
  InputPeruvianDocument,
  InputPeruvianPhoneNumber,
  InputPeruvianZipcode,
} from './peruvian';

import {
  InputChileanDocument,
  InputChileanPhoneNumber,
  InputChileanZipcode,
} from './chilean';

import {
  InputBolivianPhoneNumber,
} from './bolivian';

import {
  InputUruguayanDocument,
  InputUruguayanZipcode,
} from './uruguayan';

import {
  InputParaguayanDocument,
  InputParaguayanPhoneNumber,
  InputParaguayanZipcode,
} from './paraguayan';

import {
  InputKenyanPhoneNumber,
} from './kenyan';

import {
  InputNigerianPhoneNumber,
} from './nigerian';

import { InputHolder } from '../commons';

export function CustomerForm(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="field_brazilian_zipcode">
        <InputBrazilianZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_customer_name">
        <InputCustomerName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_customer_email">
        <InputCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_brazilian_document">
        <InputBrazilianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_document">
        <InputPeruvianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_document">
        <InputChileanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_document_type">
        <InputHolder>
          <InputArgentineDocumentType />
        </InputHolder>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_document">
        <InputHolder>
          <InputArgentineDocument />
        </InputHolder>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_phone_number">
        <InputArgentinePhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_phone_number">
        <InputChileanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_bolivian_phone_number">
        <InputBolivianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ecuadorian_document">
        <InputEcuadorianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ecuadorian_phone_number">
        <InputEcuadorianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_zipcode">
        <InputArgentineZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_zipcode">
        <InputPeruvianZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_brazilian_phone_number">
        <InputBrazilianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_mexican_zipcode">
        <InputMexicanZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_zipcode">
        <InputChileanZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_mexican_phone_number">
        <InputMexicanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_zipcode">
        <InputColombianZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_document_type">
        <InputHolder>
          <InputColombianDocumentType />
        </InputHolder>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_document">
        <InputHolder>
          <InputColombianDocument />
        </InputHolder>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_phone_number">
        <InputHolder>
          <InputColombianPhoneNumber />
        </InputHolder>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_phone_number">
        <InputPeruvianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_uruguayan_document">
        <InputUruguayanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_uruguayan_zipcode">
        <InputUruguayanZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_paraguayan_document">
        <InputParaguayanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_paraguayan_phone_number">
        <InputParaguayanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_paraguayan_zipcode">
        <InputParaguayanZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_kenyan_phone_number">
        <InputKenyanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_nigerian_phone_number">
        <InputNigerianPhoneNumber />
      </IfFeature>
    </>
  );
}
